/**
 * กำลังภายใน (qi, the blue bar): the whole qi economy in one place.
 *
 * Goal (the user, 2026-10-08: "a few skills and the bar is empty"): a fresh character chains about
 * 6–8 moves in a fight before running dry, and is full again between pulls without waiting. The
 * skills' own costs (data/skills.ts) are untouched, so power vs break vs heal stays as it was;
 * guard-breaks, buffs and heals still cost nothing. The triangle feeds the bar: a basic cut that
 * lands and a blow caught on the guard both give qi back.
 *
 * Who uses it: the player (stats.ts deriveStats, systems/qiFlow.ts). Monsters' moves cost no qi;
 * rivals, arena and roaming opponents are refilled every tick (world.ts), so they are paced by
 * their cooldowns and decision timers, not by this block.
 */
export const QI = {
  /** Pool: base + (ing + spi) × perPoint. Fresh (10/10): 140 (was 40 + 3 × 20 = 100). */
  poolBase: 60,
  poolPerPoint: 4,
  /** Regeneration per second, also in a fight: base + spi × perSpi. Fresh: 5/s (was 2.7/s). */
  regenBase: 3,
  regenPerSpi: 0.2,
  /** A basic cut that lands (hit, interrupt or guard-break) gives back this much qi. */
  perBasicHit: 3,
  /** Catching a blow on the guard (outcome 'blocked') gives back this much qi. */
  perBlock: 8,
  /** Out of combat, on top of regeneration: this share of the pool per second (full in ~8 s). */
  outOfCombatPerSec: 0.12,
  /** Meditating (นั่งสมาธิ), on top of the above: this share of the pool per second (full in ~2.5 s). */
  meditatePerSec: 0.3,
} as const;
